import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "./App.css";

import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Landing from "./pages/Landing";
import Search from "./pages/Search";
import PartDetail from "./pages/PartDetail";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import Login from "./pages/Login";
import Register from "./pages/Register";
import AuthCallback from "./pages/AuthCallback";
import Dashboard from "./pages/Dashboard";
import Seller from "./pages/Seller";
import Agent from "./pages/Agent";
import Admin from "./pages/Admin";
import HowItWorks from "./pages/HowItWorks";

function Shell() {
  const loc = useLocation();

  // Synchronous handling of Google OAuth return (prevents race conditions)
  if (loc.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <div className="flex flex-col min-h-screen bg-[#F8F9FA] text-[#121212]">
      <Header />
      <div className="flex-1">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/search" element={<Search />} />
          <Route path="/parts/:id" element={<PartDetail />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/seller" element={<Seller />} />
          <Route path="/agent" element={<Agent />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
      <Footer />
      <Toaster position="top-right" richColors closeButton />
    </div>
  );
}

function NotFound() {
  return (
    <main className="max-w-[600px] mx-auto px-4 py-24 text-center">
      <div className="font-display text-7xl font-extrabold text-[#009A44]">404</div>
      <h1 className="font-display text-3xl font-extrabold mt-2">Page not found</h1>
      <p className="text-zinc-500 mt-2">That part of the road isn't paved yet.</p>
    </main>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <Shell />
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
